var base64 = require("base-64");
export const jwtData = (token) => {
  const data = token.split(".")[1];
  const decodedData = base64.decode(data);
  const parsedData = JSON.parse(decodedData);
  return parsedData;
};
